import { render, staticRenderFns } from "./BindingWebchat.vue?vue&type=template&id=8f409e8a&"
import script from "./BindingWebchat.vue?vue&type=script&lang=js&"
export * from "./BindingWebchat.vue?vue&type=script&lang=js&"
import style0 from "./BindingWebchat.vue?vue&type=style&index=0&id=8f409e8a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports